import PropTypes from 'prop-types'
import { useState } from 'react'
import { ListGroup, ListGroupItem, CustomInput, Collapse } from 'reactstrap'

const propTypes = {
  formik               : PropTypes.object,
  fieldName            : PropTypes.string,
  brandClassifications : PropTypes.arrayOf(PropTypes.object)
}

const defaultProps = {
  formik               : {},
  fieldName            : '',
  brandClassifications : [ {} ]
}

/**
 * @param {string} name - name of the field in formik
 * @param {[string]} brandClassifications - options for brand classifications
 */
const ProductBrandClassificationFilterField = ({
  formik,
  fieldName,
  brandClassifications
}) => {

  const [ collapse, setCollapse ] = useState(true)

  const handleChange = (event, brandClassification) => {
    const { checked }           = event.target
    const brandClassificationId = brandClassification.id
    if (checked) {
      // manually push to formik values
      const newBrandClassificationIds = [ ...formik.values[ fieldName ], brandClassificationId ]
      formik.setFieldValue(fieldName, newBrandClassificationIds)
    } else {
      const newBrandClassificationIds = formik.values[ fieldName ]
        .filter((formikBrandClassificationId) => formikBrandClassificationId !== brandClassificationId)
      formik.setFieldValue(fieldName, newBrandClassificationIds)
    }
  }

  return (
    <>
      <div className='filter-title font-weight-bold pb-2'
        onClick={ () => setCollapse(!collapse) }
      >
        { 'BRAND CLASSIFICATION' }
        <i className={ `float-right fas fa-chevron-${ collapse ? 'up' : 'down' }` } />
      </div>

      <Collapse isOpen={ collapse }>
        <ListGroup flush>
          {
            brandClassifications.map((brandClassification) => (
              <ListGroupItem
                key={ `brandClassifications-filter-options-${brandClassification.id}` }
                name='brand_classification_ids'
              >
                <CustomInput
                  id={ brandClassification.name }
                  name={ brandClassification.name }
                  type='checkbox'
                  checked={ formik.values[fieldName].includes(brandClassification.id) }
                  onChange={ (event) => handleChange(event, brandClassification) }
                  className='float-left'
                  label={ brandClassification.name }
                />
              </ListGroupItem>
            ))
          }
        </ListGroup>
      </Collapse>
    </>
  )
}

ProductBrandClassificationFilterField.propTypes    = propTypes
ProductBrandClassificationFilterField.defaultProps = defaultProps

export default ProductBrandClassificationFilterField
